/**
 * Header Component
 * Main application header with user info and navigation
 */

import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useAuth();

  /**
   * Handle user logout
   */
  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="app-title">Grysolle-Petrov</h1>
          <p className="app-subtitle">Investment Tracker</p>
        </div>
        
        <div className="header-right">
          {user && (
            <div className="user-info">
              <div className="user-details">
                <span className="user-name">
                  {user.firstName} {user.lastName}
                </span>
                <span className="user-email">{user.email}</span>
                {user.isAdmin && (
                  <span className="admin-badge">👑 Admin</span>
                )}
              </div>
              
              <div className="header-actions">
                {user.isAdmin && (
                  <button 
                    onClick={() => window.location.href = '/admin'}
                    className="admin-button"
                    title="Admin Dashboard"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
                    </svg>
                    Admin
                  </button>
                )}
                
                <button 
                  onClick={handleLogout}
                  className="logout-button"
                  title="Sign out"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16,17 21,12 16,7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  Sign Out
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
